import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {INDUCT_CAMERA} from "../../util/RouteConstants";
import InductCameraDeviceOverviewContextProvider from "./context/InductCameraDeviceOverviewContext";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class InductCameraDevicePage extends Component {
    render() {

        const getInductCameraRoutes = () => {
            return INDUCT_CAMERA;
        }

        return (
            <Column>
                <InductCameraDeviceOverviewContextProvider>
                    <TabLayout routes={getInductCameraRoutes()} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={getInductCameraRoutes()}/>
                </InductCameraDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default InductCameraDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/InductCameraDevicePage.js